import { render, staticRenderFns } from "./RomaneioDetailsModal.vue?vue&type=template&id=15310e3c"
import script from "./RomaneioDetailsModal.vue?vue&type=script&lang=js"
export * from "./RomaneioDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RomaneioDetailsModal.vue?vue&type=style&index=0&id=15310e3c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15310e3c')) {
      api.createRecord('15310e3c', component.options)
    } else {
      api.reload('15310e3c', component.options)
    }
    module.hot.accept("./RomaneioDetailsModal.vue?vue&type=template&id=15310e3c", function () {
      api.rerender('15310e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customReports/components/modals/RomaneioDetailsModal.vue"
export default component.exports